<template>
    <div class="sessions">
        <Header/>



        <!--<nav class="sessionsNav">
            <li class="nav-item"><a><router-link to="/keynotes">Keynotes</router-link></a></li>
            <li class="nav-item"><a><router-link to="/breakoutsessions">Breakout Sessions</router-link></a></li>
            <li class="nav-item"><a><router-link to="/solutionsessions">Solution Sessions</router-link></a></li>
            <li class="nav-item"><a><router-link to="/partnersessions">Partner Sessions</router-link></a></li>
        </nav>-->

        <!-- Bizzabo Web Agenda Begin -->
        <div name="bizzabo-web-agenda" data-unique-name="237853" data-events-url="https://events.bizzabo.com"></div>

    </div>
</template>





<script>
    import Header from "../components/Header.vue";
    export default {
        name: "Sessions",

      data () {
        return {
          magicLink: localStorage.getItem('magicLink'),
          userId : localStorage.getItem('user_id')
        }
      },
        components: {
            Header
        },
        mounted() {
            /* Bizzabo Web Agenda Begin */
            var bz = document.createElement('script');
            bz.type = 'text/javascript';
            bz.async = true;
            bz.src = 'https://organizer.bizzabo.com/widgets/agenda/agenda.js';
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(bz, s);
            /* Bizzabo Web Agenda End */
        },

      created () {
        let userID = localStorage.getItem('user_id');

        this.$ga.set({'dimension1': userID})
        this.$ga.set({'user_id': userID})

        console.log("user_id"+ userID);
      }
    }


</script>


<style scoped>

    /*
    .sessionsNav {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-content: center;
        align-items: center;
        border-bottom: #005F4B solid 1px;
    }

    .sessionsNav li {
        list-style-type: none;
        padding: 20px;
    }

    .sessionsNav a {
        text-decoration: none;
        color: #005F4B;
        font-family: guardianfont;
        font-size: 17px;
        line-height: 10px;
    }


    /*Hovers
    .sessionsNav li:hover {
        background-color: #005f4b3f;
    }
    */

</style>